import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs';

@Component({
	selector: 'ivva-auth',
	standalone: true,
	templateUrl: './auth.component.html',
	styleUrls: ['./auth.component.scss'],
})
export class AuthComponent implements OnInit {
	private readonly route = inject(ActivatedRoute);

	// constructor(, private router: Router, private store: Store<IvvStore>) {}

	ngOnInit() {
		this.useCode();
	}

	private useCode() {
		this.route.queryParamMap.pipe(take(1)).subscribe((q) => {
			const devmode = localStorage.getItem('devmode') === 'true' || localStorage.getItem('devmode') === '1';

			if (!devmode) {
				if (q.has('code')) {
					// this.store.dispatch(APP_DATA_ACTIONS.addLoading({ message: 'Bezig met laden. Even geduld aub...' }));

					const code = q.get('code') as string;
					const state = q.get('state') as string;

					location.href = `/code?code=${code}&state=${state}`;
				} else {
					// this.error();
				}
			}
		});
	}
}
